import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M1 1l4 4 4-4" stroke="#A7A7A7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>);